const _ = require('underscore');

class AssetSearch {
  constructor($status, assetSearchUrl, successCallback) {
    this.status = $status;
    this.assetSearchUrl = assetSearchUrl;
    this.successCallback = successCallback;
  }

  getAssetsByPositionBounds(bounds, filters, currentLocation) {
    if (filters == null) {
      filters = {};
    }
    if (currentLocation == null) {
      currentLocation = {};
    }
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const searchData = {
      bounds: {
        ne: { lat: ne.lat(), lng: ne.lng() },
        sw: { lat: sw.lat(), lng: sw.lng() },
      },
      filters,
    };

    return this.getAssets($.extend(searchData, currentLocation));
  }

  getAssets(searchData) {
    this.status.empty();
    return $.ajax({
      url: this.assetSearchUrl,
      type: 'GET',
      dataType: 'json',
      data: searchData,
      beforeSend: () => {
        return this.status.append(
          '<p class="loading">Loading assets... This may take a moment...</p>',
        );
      },
      error: () => {
        this.status.empty();
        return this.status.append(
          "<p class='error'>Please refresh your browser. If that does not work, please contact us by clicking on the blue help box in the bottom right.</p>",
        );
      },
      success: (data) => {
        this.status.empty();
        return this.successCallback(
          data.assets,
          data.data_summary,
          data.user_locations,
        );
      },
    });
  }
}

//-----------  Export  -----------#
module.exports = AssetSearch;
